import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';

import DatePicker from './DatePicker';
import classNames from 'classnames';
import AppContext from 'context/Context';
import useApi from 'hooks/useApi';
import {
  createProject,
  getCountries,
  getStates
} from 'api/endpoints/ManagementServices';
import { first, isEmpty } from 'lodash';
import { has } from 'lodash';
import { get } from 'lodash';
import MapLayers from './MapLayers';

import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  OverlayTrigger,
  Row,
  ToggleButton
} from 'react-bootstrap';
import format from 'date-fns/format';
import Loader from 'components/common/Loader';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faFileUpload,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';

import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

import wellknown from 'wellknown';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import {
  DownloadBoundaryTemplatePopover,
  UploadBoundaryFilePopover
} from './Popover';
import CustomSelect from 'components/common/CustomSelect';
import { addDays } from '@fullcalendar/react';
import { jwtDecode } from 'jwt-decode';
import { getTenantFromToken } from 'utils/routeUtils';

const NewProject = () => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const tenant = getTenantFromToken();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const [projectName, setProjectName] = useState('');
  const [evaluationEnabled, setEvaluationEnabled] = useState(true);
  const [monitoringEnabled, setMonitoringEnabled] = useState(false);
  const [monitoringStartDate, setMonitoringStartDate] = useState(null);
  const [monitoringEndDate, setMonitoringEndDate] = useState(null);
  const [frequency, setFrequency] = useState('Monthly');

  const [mapLayer, setMapLayer] = useState(null);

  const [plotUploadFile, setPlotUploadFile] = useState(false);
  const [hasLayer, setHasLayer] = useState(false);
  const [geojsonData, setGeojsonData] = useState({});
  const [area, setArea] = useState(0);
  const mapRef = useRef();
  const drawnShapeRef = useRef(null);
  const featureGroupRef = useRef();

  const [country, setCountry] = useState(null);
  const [countriesList, setCountriesList] = useState([
    { label: 'Loading.....', isDisabled: true }
  ]);
  const [state, setState] = useState(null);
  const [statesList, setStatesList] = useState([]);

  const [countryError, setCountryError] = useState('');
  const [stateError, setStateError] = useState('');
  const [projectNameError, setProjectNameError] = useState('');
  const [startDateError, setStartDateError] = useState('');
  const [endDateError, setEndDateError] = useState('');
  const [plotError, setPlotError] = useState('');

  const getCountriesAPI = useApi(getCountries);
  const getStatesAPI = useApi(getStates);
  const createProjectAPI = useApi(createProject);

  const [fileName, setFileName] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadedGeojsonData, setUploadedGeojsonData] = useState({});
  const [uploadedGeoJSONLayer, setUploadedGeoJSONLayer] = useState(null);
  const [fileUploadError, setFileUploadError] = useState('');

  useEffect(() => {
    getCountriesAPI.request();
  }, []);

  useEffect(() => {
    if (country?.value) {
      setStatesList([{ label: 'Loading.....', isDisabled: true }]);
      getStatesAPI.request(country.value);
    }
  }, [country]);

  useEffect(() => {
    const countries = get(getCountriesAPI, 'data.results', []);

    const countriesList = countries.map(country => ({
      value: country.id,
      label: country.name
    }));

    !isEmpty(countriesList) && setCountriesList(countriesList);
  }, [getCountriesAPI.data]);

  useEffect(() => {
    const states = get(getStatesAPI, 'data.results', []);

    const statesList = states.map(state => ({
      value: state.id,
      label: state.name
    }));

    !isEmpty(statesList) && setStatesList(statesList);
  }, [getStatesAPI.data]);

  let newFeatures = [];

  const handleShapeEdit = (layer, isNewShape = true) => {
    setPlotError('');

    let geojson;
    let area;

    // if (layer instanceof L.Circle) {
    //   const circleToPolygon = L.PM.Utils.circleToPolygon(layer, 64);
    //   setMapLayer(circleToPolygon);
    //   geojson = circleToPolygon.toGeoJSON();
    //   area =
    //     L.GeometryUtil.geodesicArea(circleToPolygon.getLatLngs()[0]) / 10000;
    // } else {
    //   setMapLayer(layer);
    //   geojson = layer.toGeoJSON();
    //   area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]) / 10000;
    // }

    if (layer instanceof L.Circle) {
      const circleToPolygon = L.PM.Utils.circleToPolygon(layer, 64);
      setMapLayer(circleToPolygon);
      geojson = circleToPolygon.toGeoJSON();
      area =
        L.GeometryUtil.geodesicArea(circleToPolygon.getLatLngs()[0]) / 10000;
    } else {
      setMapLayer(layer);
      geojson = layer.toGeoJSON();

      if (geojson.geometry.type === 'MultiPolygon') {
        // Handle multi-polygon
        // You may want to iterate over each polygon in the MultiPolygon and process them individually
        geojson.geometry.coordinates.forEach(coordinates => {
          const polygonArea =
            L.GeometryUtil.geodesicArea(coordinates[0]) / 10000;
          // console.log('Polygon Area:', polygonArea);
        });
      } else if (geojson.geometry.type === 'Polygon') {
        // Handle single polygon
        area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]) / 10000;
      }
    }

    if (newFeatures.length > 0) {
      const firstFeature = newFeatures[0];

      firstFeature.geometry.type = 'MultiPolygon';
      firstFeature.geometry.coordinates.push(geojson.geometry.coordinates[0]);
    } else {
      newFeatures.push(geojson);
    }

    // Update state with new GeoJSON data
    setGeojsonData({
      type: 'FeatureCollection',
      features: newFeatures
    });

    // Update state with new area
    setArea(area);

    if (isNewShape) {
      // Save layer id for editing and deleting
      drawnShapeRef.current = {
        edit_id: layer._leaflet_id,
        del_id: layer._leaflet_id
      };
      setHasLayer(false);
    }
  };

  const _onCreate = e => {
    handleShapeEdit(e.layer);
  };

  const _onEdited = e => {
    const {
      target: { _layers }
    } = e;
    const layer = _layers[drawnShapeRef.current.edit_id];
    handleShapeEdit(layer, false);
  };

  // const _onEdited = e => {
  //   const {
  //     layers: { _layers }
  //   } = e;
  //   console.log(_layers, 'layers');
  //   // Object.values(_layers).map(({ _leaflet_id, editing }) => {
  //   //   setMapLayers(layers =>
  //   //     layers.map(l =>
  //   //       l.id === _leaflet_id
  //   //         ? { ...l, latlngs: { ...editing.latlngs[0] } }
  //   //         : l
  //   //     )
  //   //   );
  //   // });
  //   // const layer = _layers[drawnShapeRef.current.edit_id];
  //   // handleShapeEdit(layer, false);
  // };

  const _onDeleted = e => {
    const {
      layers: { _layers }
    } = e;

    if (has(_layers, drawnShapeRef.current.del_id)) {
      setGeojsonData({});
      newFeatures = [];
      setMapLayer(null);
      setArea(0);
      setHasLayer(false);
      setUploadedGeoJSONLayer(null);
      setUploadedGeojsonData({});
      setUploadFile(null);
    }
  };

  useEffect(() => {
    if (!hasLayer && plotUploadFile) {
      setHasLayer(true);
    }
  }, [hasLayer]);

  const handleSubmit = async event => {
    event.preventDefault(); // Prevent the default form submission

    let hasError = false;
    let hasPlotError = false;

    if (!country) {
      setCountryError('Please select a country.');
      hasError = true;
    } else {
      setCountryError('');
    }

    if (!state) {
      setStateError('Please select a state.');
      hasError = true;
    } else {
      setStateError('');
    }

    if (!projectName) {
      setProjectNameError('Please enter a project name.');
      hasError = true;
    } else {
      setProjectNameError('');
    }

    if (monitoringEnabled) {
      if (!monitoringStartDate) {
        setStartDateError('Please select a start date.');
        hasError = true;
      } else {
        setStartDateError('');
      }

      if (!monitoringEndDate) {
        setEndDateError('Please select an end date.');
        hasError = true;
      } else {
        setEndDateError('');
      }
    }

    if (!plotUploadFile && isEmpty(geojsonData)) {
      setPlotError('Please draw the plot boundary.');
      hasPlotError = true;
    } else {
      setPlotError('');
    }

    if (plotUploadFile && isEmpty(uploadedGeojsonData)) {
      setFileUploadError('Please upload file of valid format.');
      hasError = true;
    } else {
      setFileUploadError('');
    }

    if (hasError) {
      window.scrollTo(0, 0);
      return;
    }

    // scroll to the Map container if only plot dawing has missing
    if (hasPlotError) {
      const element = document.querySelector('#map');
      const top = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: 'smooth' });

      return;
    }

    // Prepare the data object to be sent in the API request
    const requestData = {
      tenant: tenant,
      country: country.value,
      state: state.value,
      project_name: projectName,
      project_area: Math.round(area),
      enable_evaluation: evaluationEnabled,
      enable_monitoring: monitoringEnabled,
      monitoring_start_date: monitoringEnabled
        ? format(monitoringStartDate, 'dd-MM-yyyy')
        : '',
      monitoring_end_date: monitoringEnabled
        ? format(monitoringEndDate, 'dd-MM-yyyy')
        : '',
      monitoring_frequency: monitoringEnabled ? frequency : '',
      feature: geojsonData
    };

    if (!area) {
      return;
    }

    createProjectAPI.request(requestData);
  };

  useEffect(() => {
    if (createProjectAPI.data?.success === true) {
      clearData();
      navigate(`/${tenant}/projects`);
    }
  }, [createProjectAPI.data]);

  useEffect(() => {
    if (createProjectAPI.error?.data?.desc === 'Duplicate Request.') {
      setProjectNameError('This project name already exists. Try another.');
      window.scrollTo(0, 0);
    } else if (!isEmpty(createProjectAPI.error)) {
      // Show a toast message
      toast.error(createProjectAPI.error?.data?.desc);
    }
  }, [createProjectAPI.error]);

  useEffect(() => {
    if (createProjectAPI.loading) {
      setRequestLoading(true);
    } else {
      setRequestLoading(false);
    }
  }, [createProjectAPI.loading]);

  const handleFileUploadClick = () => {
    document.getElementById('uploadBoundaryFileInput').click();
  };

  // const handleFileChange = async e => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const fileName = file.name;
  //     const fileExtension = getFileExtension(fileName);

  //     if (
  //       fileExtension === 'json' ||
  //       fileExtension === 'geojson' ||
  //       fileExtension === 'csv'
  //     ) {
  //       try {
  //         const fileContents = await readFileContents(file);

  //         let data;
  //         if (fileExtension === 'json' || fileExtension === 'geojson') {
  //           data = JSON.parse(fileContents);
  //         } else {
  //           data = parseCSVData(fileContents);
  //         }

  //         console.log(data, 'dataaa');
  //         setUploadedGeojsonData(data);
  //         setUploadFile(file);
  //         setFileName(fileName);
  //         setFileUploadError('');

  //         removePreviousLayers();
  //         const newGeoJSONLayer = L.geoJSON(data);
  //         console.log(newGeoJSONLayer, 'newGeoJSONLayer');
  //         const layer = Object.values(newGeoJSONLayer._layers)[0];
  //         setUploadedGeoJSONLayer(layer);

  //         const bounds = newGeoJSONLayer.getBounds();
  //         mapRef.current.fitBounds(bounds);

  //         setHasLayer(true);
  //         setGeojsonData(layer.toGeoJSON());
  //         handleShapeEdit(layer);
  //         drawnShapeRef.current.del_id = layer._leaflet_id;
  //         setMapLayer(layer);
  //       } catch (error) {
  //         console.error(error);
  //         setUploadFile(null);
  //         setFileName('');
  //         setFileUploadError('Error reading file contents.');
  //         setUploadedGeojsonData({});
  //       }
  //     } else {
  //       setUploadFile(null);
  //       setFileName('');
  //       setFileUploadError(
  //         'Invalid file format. Please upload a .geojson or .csv file.'
  //       );
  //       setUploadedGeojsonData({});
  //     }
  //   }
  // };

  const handleFileChange = async e => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name;
      const fileExtension = getFileExtension(fileName);

      if (
        fileExtension === 'json' ||
        fileExtension === 'geojson' ||
        fileExtension === 'csv'
      ) {
        try {
          const fileContents = await readFileContents(file);

          let data;
          if (fileExtension === 'json' || fileExtension === 'geojson') {
            data = JSON.parse(fileContents);
          } else {
            data = parseCSVData(fileContents);
          }

          setUploadedGeojsonData(data);
          setUploadFile(file);
          setFileName(fileName);
          setFileUploadError('');
          removePreviousLayers();
          if (
            data.type === 'FeatureCollection' &&
            data.features.every(
              feature => feature.geometry.type === 'MultiPolygon'
            )
          ) {
            const newGeoJSONLayer = L.geoJSON(data);
            const layers = Object.values(newGeoJSONLayer._layers);

            let totalArea = 0;
            layers[0]._latlngs.forEach(layer => {
              const latlngs = layer;
              const area = L.GeometryUtil.geodesicArea(latlngs[0]);
              totalArea += area;
            });

            const totalAreaHectares = totalArea / 10000;

            // console.log('Total Area:', totalAreaHectares, 'hectares');
            setArea(totalAreaHectares);
            data.features.forEach(feature => {
              const multipolygonLayer = L.geoJSON(feature);
              multipolygonLayer.addTo(mapRef.current);

              const bounds = multipolygonLayer.getBounds();
              mapRef.current.fitBounds(bounds);
            });

            setUploadedGeoJSONLayer(null);
            setGeojsonData(data);
            setHasLayer(true);
          } else {
            const newGeoJSONLayer = L.geoJSON(data);
            const layer = Object.values(newGeoJSONLayer._layers)[0];
            setUploadedGeoJSONLayer(layer);
            const bounds = newGeoJSONLayer.getBounds();
            mapRef.current.fitBounds(bounds);
            setHasLayer(true);
            setGeojsonData(layer.toGeoJSON());
            handleShapeEdit(layer);
            drawnShapeRef.current.del_id = layer._leaflet_id;
            setMapLayer(layer);
          }
        } catch (error) {
          console.error(error);
          setUploadFile(null);
          setFileName('');
          setFileUploadError('Error reading file contents.');
          setUploadedGeojsonData({});
        }
      } else {
        setUploadFile(null);
        setFileName('');
        setFileUploadError(
          'Invalid file format. Please upload a .geojson or .csv file.'
        );
        setUploadedGeojsonData({});
      }
    }
  };

  const getFileExtension = fileName => {
    const fileParts = fileName.split('.');
    return fileParts[fileParts.length - 1].toLowerCase();
  };

  const readFileContents = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = event => {
        resolve(event.target.result);
      };
      reader.onerror = event => {
        reject(event.error);
      };
      reader.readAsText(file);
    });
  };

  const parseCSVData = csvData => {
    const result = Papa.parse(csvData, { header: true });
    const records = result.data;
    return {
      type: 'FeatureCollection',
      features: records
        .map(record => {
          try {
            return {
              type: 'Feature',
              geometry: wellknown.parse(record.wkt),
              properties: record
            };
          } catch (error) {
            console.error(error);
            return null;
          }
        })
        .filter(feature => feature !== null)
    };
  };

  const removePreviousLayers = () => {
    if (uploadedGeoJSONLayer) {
      mapRef.current.removeLayer(uploadedGeoJSONLayer);
      setUploadedGeoJSONLayer(null);
      setGeojsonData({});
    }

    if (mapLayer) {
      mapRef.current.removeLayer(mapLayer);
      setMapLayer(null);
      setGeojsonData({});
    }
  };

  const handlePlotInputChange = () => {
    setPlotUploadFile(false);
    setFileName('');
    setGeojsonData({});
    setUploadedGeoJSONLayer(null);
    setHasLayer(false);
    featureGroupRef.current.clearLayers();
  };

  function handleDownloadTemplate(e) {
    const selectedValue = e.target.value;
    let fileUrl, fileName;
    if (selectedValue === 'geojson') {
      fileUrl = '/json/geojson_sample.json';
      fileName = 'geojson_sample.json';
    } else if (selectedValue === 'wkt') {
      fileUrl = '/json/wkt_sample.csv';
      fileName = 'wkt_sample.csv';
    }
    saveAs(fileUrl, fileName);
  }

  const clearData = () => {
    setProjectName('');
    setMonitoringEnabled(false);
    setMonitoringStartDate(null);
    setMonitoringEndDate(null);
    setFrequency('monthly');
    setMapLayer(null);
    setPlotUploadFile(false);
    setHasLayer(false);
    setGeojsonData({});
    setArea(0);
    setCountry(null);
    setState(null);

    setFileName('');
    setUploadFile();
    setUploadedGeojsonData({});
    setUploadedGeoJSONLayer(null);

    setCountryError('');
    setStateError('');
    setProjectNameError('');
    setStartDateError('');
    setEndDateError('');
    setPlotError('');
    setFileUploadError('');
  };

  const handleCancel = () => {
    clearData();
    featureGroupRef.current.clearLayers();
    window.scrollTo(0, 0);
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate('/')}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>Create New Project</span>
    </div>
  );

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {requestLoading && <Loader />}
          <Row>
            <Col>
              <Card className="mt-2">
                <FalconCardHeader
                  title={header}
                  className="ps-lg-4"
                  titleTag="h5"
                  titleClass="mb-0"
                  light
                />
                <Card.Body className="p-lg-4">
                  <Form onSubmit={handleSubmit}>
                    <Form.Group
                      className="mb-4"
                      controlId="formBasicProjectInfo"
                    >
                      <Row className="g-3 g-lg-4">
                        <Col lg={4}>
                          <Form.Label>Country</Form.Label>
                          <CustomSelect
                            required
                            options={countriesList}
                            placeholder="Select Country"
                            classNamePrefix="react-select"
                            onChange={value => {
                              setCountry(value);
                              setCountryError('');
                              setState(null);
                            }}
                            value={country}
                            className={
                              countryError ? 'form-control is-invalid p-0' : ''
                            }
                          />
                          {!isEmpty(countryError) && (
                            <div className="invalid-feedback">
                              {countryError}
                            </div>
                          )}
                        </Col>
                        <Col lg={4}>
                          <Form.Label>State</Form.Label>
                          <CustomSelect
                            options={statesList}
                            placeholder="Select State"
                            classNamePrefix="react-select"
                            className={
                              stateError ? 'form-control is-invalid p-0' : ''
                            }
                            value={state}
                            onChange={value => {
                              setState(value);
                              setStateError('');
                            }}
                            onFocus={() => {
                              !country &&
                                setCountryError('Please select a country.');
                            }}
                          />
                          {!isEmpty(stateError) && (
                            <Form.Control.Feedback type="invalid">
                              {stateError}
                            </Form.Control.Feedback>
                          )}
                        </Col>
                        <Col lg={4}>
                          <Form.Label>Project Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Project Name"
                            value={projectName}
                            onChange={e => {
                              setProjectName(e.target.value);
                              setProjectNameError('');
                            }}
                            isInvalid={Boolean(projectNameError)}
                          />
                          {!isEmpty(projectNameError) && (
                            <div className="invalid-feedback">
                              {projectNameError}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="formMonitoringInfo">
                      <Row className="g-3 g-lg-4">
                        <Col lg={4}>
                          <Row>
                            <Col>
                              <Form.Label>Enable Evaluation</Form.Label>
                              <ButtonGroup className="d-block">
                                <ToggleButton
                                  id="evaluationEnabled-false"
                                  type="radio"
                                  className="px-3"
                                  name="evaluationEnabled"
                                  variant={
                                    !evaluationEnabled ? 'primary' : 'light'
                                  }
                                  checked={!evaluationEnabled}
                                  onChange={() => setEvaluationEnabled(false)}
                                >
                                  No
                                </ToggleButton>
                                <ToggleButton
                                  id="evaluationEnabled-true"
                                  type="radio"
                                  className="px-3"
                                  name="evaluationEnabled"
                                  variant={
                                    evaluationEnabled ? 'primary' : 'light'
                                  }
                                  checked={evaluationEnabled}
                                  onChange={() => setEvaluationEnabled(true)}
                                >
                                  Yes
                                </ToggleButton>
                              </ButtonGroup>
                            </Col>
                            <Col>
                              <Form.Label>Enable Monitoring</Form.Label>
                              <ButtonGroup className="d-block">
                                <ToggleButton
                                  id="monitoringEnabled-false"
                                  type="radio"
                                  className="px-3"
                                  name="monitoringEnabled"
                                  variant={
                                    !monitoringEnabled ? 'primary' : 'light'
                                  }
                                  checked={!monitoringEnabled}
                                  onChange={() => setMonitoringEnabled(false)}
                                >
                                  No
                                </ToggleButton>
                                <ToggleButton
                                  id="monitoringEnabled-true"
                                  type="radio"
                                  className="px-3"
                                  name="monitoringEnabled"
                                  variant={
                                    monitoringEnabled ? 'primary' : 'light'
                                  }
                                  checked={monitoringEnabled}
                                  onChange={() => setMonitoringEnabled(true)}
                                >
                                  Yes
                                </ToggleButton>
                              </ButtonGroup>
                            </Col>
                          </Row>
                        </Col>

                        <Col
                          lg={4}
                          className={!monitoringEnabled && 'opacity-50'}
                        >
                          <Form.Label>Monitoring Date Range</Form.Label>
                          <Row className="g-0">
                            <Col
                              className={classNames(' me-2', {
                                'form-control is-invalid p-0': startDateError
                              })}
                            >
                              <DatePicker
                                disabled={!monitoringEnabled}
                                selected={monitoringStartDate}
                                onChange={date => {
                                  setMonitoringStartDate(date);
                                  setStartDateError('');
                                }}
                                placeholderText="From"
                                minDate={addDays(new Date(), 1)}
                              />
                            </Col>

                            <Col
                              className={classNames(' ms-2', {
                                'form-control is-invalid p-0': endDateError
                              })}
                            >
                              <DatePicker
                                disabled={
                                  !monitoringEnabled || !monitoringStartDate
                                }
                                selected={monitoringEndDate}
                                onChange={date => {
                                  setMonitoringEndDate(date);
                                  setEndDateError('');
                                }}
                                placeholderText="To"
                                minDate={
                                  monitoringStartDate
                                    ? addDays(monitoringStartDate, 1)
                                    : null
                                }
                                maxDate={
                                  new Date(
                                    monitoringStartDate?.getFullYear() + 3,
                                    monitoringStartDate?.getMonth(),
                                    monitoringStartDate?.getDate()
                                  )
                                }
                              />
                            </Col>
                            {Boolean(endDateError || startDateError) && (
                              <div className="invalid-feedback">
                                Please select a valid date range.
                              </div>
                            )}
                          </Row>
                        </Col>
                        <Col
                          lg={4}
                          className={!monitoringEnabled && 'opacity-50'}
                        >
                          <Form.Label>Frequency</Form.Label>
                          <Form.Select
                            className={!isDark && 'bg-white'}
                            disabled={!monitoringEnabled}
                            aria-label="Monitoring Frequency select"
                            value={frequency}
                            onChange={e => setFrequency(e.target.value)}
                          >
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Half-Yearly">Half-Yearly</option>
                            <option value="Yearly">Yearly</option>
                          </Form.Select>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="formPlotInfo">
                      <Row className="g-3 g-lg-4">
                        <Col lg={4}>
                          <Form.Label>Plot Boundary</Form.Label>
                          <ButtonGroup className="d-block">
                            <ToggleButton
                              id="plotUploadFile-false"
                              type="radio"
                              className="px-4"
                              name="plotUploadFile"
                              variant={!plotUploadFile ? 'primary' : 'light'}
                              checked={!plotUploadFile}
                              onChange={handlePlotInputChange}
                            >
                              Draw
                            </ToggleButton>
                            <ToggleButton
                              id="plotUploadFile-true"
                              type="radio"
                              className="px-4"
                              name="plotUploadFile"
                              variant={plotUploadFile ? 'primary' : 'light'}
                              checked={plotUploadFile}
                              onChange={() => {
                                setPlotUploadFile(true);
                                setHasLayer(true);
                                featureGroupRef.current.clearLayers();
                              }}
                            >
                              Upload
                            </ToggleButton>
                          </ButtonGroup>
                        </Col>
                        {plotUploadFile && (
                          <>
                            <Col lg={4}>
                              <Form.Label>
                                Upload Boundary File
                                <OverlayTrigger
                                  trigger={['hover', 'focus']}
                                  placement="bottom"
                                  overlay={UploadBoundaryFilePopover}
                                >
                                  <span>
                                    <FontAwesomeIcon
                                      icon={faInfoCircle}
                                      className="ms-1 text-light"
                                      id="uploadBoundaryFileTooltip"
                                    />
                                  </span>
                                </OverlayTrigger>
                              </Form.Label>
                              <div
                                className={classNames(' input-group', {
                                  'form-control is-invalid p-0': fileUploadError
                                })}
                                onClick={handleFileUploadClick}
                              >
                                <Form.Control
                                  type="text"
                                  readOnly
                                  value={fileName}
                                  placeholder="Select a file"
                                />
                                <span className="input-group-text px-2 rounded-1">
                                  <FontAwesomeIcon icon={faFileUpload} />
                                </span>

                                <input
                                  id="uploadBoundaryFileInput"
                                  hidden
                                  type="file"
                                  onChange={handleFileChange}
                                />
                              </div>
                              {fileUploadError && (
                                <Form.Text className="text-danger">
                                  {fileUploadError}
                                </Form.Text>
                              )}
                            </Col>
                            <Col lg={4}>
                              <Form.Label>
                                Download Boundary Templates
                                <OverlayTrigger
                                  trigger={['hover', 'focus']}
                                  placement="bottom"
                                  overlay={DownloadBoundaryTemplatePopover}
                                >
                                  <span>
                                    <FontAwesomeIcon
                                      icon="info-circle"
                                      className="ms-1 text-light"
                                      id="downloadBoundaryTemplatesTooltip"
                                    />
                                  </span>
                                </OverlayTrigger>
                              </Form.Label>
                              <Form.Select
                                className={!isDark && 'bg-white'}
                                aria-label="Download Boundary Templates"
                                placeholder="Download Template"
                                value={''}
                                onChange={handleDownloadTemplate}
                              >
                                <option value="" disabled>
                                  Download Template
                                </option>
                                <option value="geojson">
                                  GeoJSON Template
                                </option>
                                <option value="wkt">{`WKT Template (.csv)`}</option>
                              </Form.Select>
                            </Col>
                          </>
                        )}
                      </Row>
                    </Form.Group>

                    <Col
                      className={classNames('rounded-3 overflow-hidden', {
                        'border border-2 border-danger': plotError
                      })}
                    >
                      <MapContainer
                        id="map"
                        style={{ minHeight: '400px' }}
                        className="h-100 bg-white w-100 "
                        center={{ lat: 20.5937, lng: 78.9629 }}
                        zoom={4}
                        minZoom={1.3}
                        zoomSnap={0.5}
                        whenReady={mapInstance =>
                          (mapRef.current = mapInstance)
                        }
                        ref={mapRef}
                      >
                        <MapLayers
                          plotUploadFile={plotUploadFile}
                          uploadedGeoJSONLayer={uploadedGeoJSONLayer}
                          featureGroupRef={featureGroupRef}
                          hasLayer={hasLayer}
                          _onCreate={_onCreate}
                          _onEdited={_onEdited}
                          _onDeleted={_onDeleted}
                        />
                        <TileLayer
                          attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a>'
                          url={`https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_PUBLIC_KEY}`}
                        />
                      </MapContainer>
                    </Col>
                    <span className="text-danger fs--1">{plotError}</span>
                    {/* <Col>
                      <pre className="text-left">
                        <span>Area: {Math.round(area)} h</span>
                        <br />
                        {JSON.stringify(geojsonData, 0, 2)}
                      </pre>
                    </Col> */}
                    <Col className="d-flex justify-content-end mt-4">
                      <Button
                        className="me-3"
                        onClick={handleCancel}
                        variant="light"
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </Col>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default NewProject;
